import { render, staticRenderFns } from "./SecureLinkInformation.vue?vue&type=template&id=764a4d68"
import script from "./SecureLinkInformation.vue?vue&type=script&lang=js"
export * from "./SecureLinkInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports